// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"b05d2b558ffc55a43547","411":"ff4d22414754e8c0b705","673":"cdcfcbe15627125d6845"}[chunkId] + ".chunk.js";
};